var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{directives:[{name:"in-viewport",rawName:"v-in-viewport",value:({ top: -50 }),expression:"{ top: -50 }"}],staticClass:"section-title"},[_c('span',{staticClass:"section-title__content"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565bc845","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionTitle.vue
// module id = null
// module chunks = 